import { configureStore } from "@reduxjs/toolkit";
import systemReducer from "../reducers/systemSlice.js";
import propertiesReducer from "../reducers/propertiesSlice";
import searchReducer from "../reducers/searchSlice";
import hotelReducer from "../reducers/hotelSlice";

import offersReducer from "../reducers/offersSlice";
import filterReducer from "../reducers/filterSlice";
import bookingReducer from "../reducers/bookingSlice";
import flightReducer from "../reducers/flightSlice";
import languageReducer from "../reducers/languageSlice";
import cacheReducer from "../reducers/cacheSlice";

import { configurationReducers } from "../reducers/configuartionSlice";

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  reducer: {
    ...configurationReducers,
    system: systemReducer,
    properties: propertiesReducer,
    search: searchReducer,
    hotel: hotelReducer,
    cache: cacheReducer,
    offers: offersReducer,
    filter: filterReducer,
    booking: bookingReducer,
    flight: flightReducer,
    language: languageReducer,
  },
  //middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  //devTools: process.env.NODE_ENV !== "production",
});
